import { Button } from "@babackapp/ui/components/button";
import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function BackButton() {
  return (
    <Link to="..">
      <Button variant="outline" size="sm">
        <ChevronLeft className={"h-4 w-4"} />
      </Button>
    </Link>
  );
}
